import React, { useState, useMemo } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  FormGroup,
  InputGroup,
  FormControl,
} from "react-bootstrap";
import { injectIntl } from "react-intl";
import { useQuery, useMutation, queryCache } from "react-query";
import Alert from "react-s-alert";

import PageLoading from "../../../components/Loading";
import RoomRow from "../../../components/rooms/row";
import ArchiveHeader from "../../../components/ArchiveHeader";

import CreateItemForm from '../../../components/CreateItemForm';
import Table from '../../../components/TableNew';
import SortButton from "../../../components/SortButton";
import { getRooms, deleteRoom } from "./xhr";

const Rooms = ({ intl, locale, setLocale }) => {
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("name");
  const [order, setOrder] = useState("asc");
  const [roomName, setRoomName] = useState('');
  const [showSort, setShowSort] = useState(false);

  const { isLoading, isError, error, data: rooms } = useQuery('rooms', getRooms, {
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  });

  const [deleteRoomMutation] = useMutation(deleteRoom, {
    onSuccess: (deletedRoom) => {
      if(queryCache.getQueryData('rooms')) {
        // console.log(deletedRoom);
        queryCache.setQueryData('rooms', rooms => rooms
          .filter(room => room._id !== deletedRoom._id)
        )
      }
      Alert.success(intl.formatMessage({ id: 'room.delete-success' }));
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  })

  // useEffect(() => {
  //   async function asyncDispatchSpekearGetAll() {
  //     dispatch(roomGetAll()).catch((err) =>
  //       Alert.error(intl.formatMessage({ id: err.message }))
  //     );
  //   }
  //   asyncDispatchSpekearGetAll();
  // }, [dispatch, intl]);

  const columns = React.useMemo(
    () => [
      {
        Header: 'Rooms',
        accessor: ({ _id, ...row }) => {
          return Object.values(row).join("|");
        },
        Cell: ({ cell: { value }, row: { original } }) => (
          <RoomRow
            key={original._id}
            login={original.login}
            name={original.name}
            order={original.order}
            token={original.token}
            id={original._id}
            deleteFn={(_id) => {
              deleteRoomMutation({ _id })
            }}
          />
        )
      },
    ],
    [deleteRoomMutation]
  )

  const sortOptions = useMemo(() => [
    {
      label: 'input.room.name',
      value: 'name',
      sort: (a, b) => a.name.localeCompare(b.name),
    },
    {
      label: 'input.room.login-short',
      value: 'login',
      sort: (a, b) => a.login.localeCompare(b.login),
    },
    {
      label: 'input.room.order',
      value: 'order',
      sort: (a, b) => a.order - b.order,
    },
  ], []);

  if (isLoading) {
    return <PageLoading />;
  }

  if (isError) {
    return <span>Error: {error.message}</span>
  }

  return (
    <React.Fragment>
      <ArchiveHeader locale={locale} setLocale={setLocale} intl={intl} title="heading.rooms" />
      <div className="pad-2rem">
        <Container fluid>
          <Row className="align-items-center m-b-20">
            <Col xl={6}>
              <CreateItemForm
                heading="button.createRoom"
                setFunc={setRoomName}
                placeholder={intl.formatMessage({ id: 'input.room.name' })}
                link={`/room/add/${roomName}`}
              />
            </Col>
            <Col xl={6}>
              <Row>
                <Col md={6}>
                  <div className="text-right search-container">
                    <FormGroup>
                      <InputGroup onChange={(e) => setSearch(e.target.value)}>
                        <FormControl type="text" />
                        <InputGroup.Append>
                          <Button>
                            <img src="/icons/search.png" alt="plus" />
                          </Button>
                        </InputGroup.Append>
                      </InputGroup>
                    </FormGroup>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="dropdown-filters">
                    {/* <FormGroup controlId="sort" className="sort-filter">
                      <img className="sort-icon" alt="" src="/icons/list.png" />
                      <FormControl onChange={(e) => setSort(e.target.value)} as="select">
                        {
                          sortOptions.map((o, i) => (
                            <option key={i} value={o.value} selected={o.value === sort}>{intl.formatMessage({ id: o.label })}</option>
                          ))
                        }
                      </FormControl>
                    </FormGroup> */}
                    <SortButton
                      showSort={showSort}
                      setShowSort={setShowSort}
                      sortOptions={sortOptions}
                      intl={intl}
                      setSort={setSort}
                      sort={sort}
                      order={order}
                      setOrder={setOrder}
                    />
                    {/* <Button className="sort-btn" onClick={() => setOrder(order === "asc" ? "desc" : "asc")}>
                    {order === "asc" ? <i className="fas fa-sort-amount-down-alt"></i> : <i className="fas fa-sort-amount-down"></i>}
                    </Button> */}
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col>
              <Table
                columns={columns}
                data={rooms
                  .sort(sortOptions.find((so) => so.value === sort).sort)
                  .map((d, i) => ({
                    ...d, i: i
                    * (order === "asc" ? 1 : -1)
                  }))
                  .sort((a, b) => a.i - b.i)}
                search={search}
                intl={intl}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment >
  );
};

// const mapStateToProps = (state) => ({
//   rooms: state.room.allRooms,
//   userProfile: state.user.profile,
// });

// export default connect(mapStateToProps)(injectIntl(Rooms));

export default injectIntl(Rooms);
